<ng-container *transloco="let t">
  <div class="error-container">
    <div class="title" *ngIf="title">{{ title }}</div>
    <web-di-ld-apply-error
      [path]="path"
      title="{{ t('applyError.' + case + '.title') }}"
      description="{{ t('applyError.' + case + '.description') }}"
    ></web-di-ld-apply-error>
    <web-di-ld-button
      label="{{ t('common.ok') }}"
      (click)="emitClickEvt()"
    ></web-di-ld-button>
  </div>
</ng-container>
